// @ts-check
import { useController, RegisterOptions } from 'react-hook-form';
import { TextInput } from '../../../newComponents/TextInput';
import { applySanitizers } from '../../../utils/sanitizers';
import { ControlledVideoAgreementTemplateNameInputProps } from './ControlledVideoAgreementTemplateNameInput.types';

const defaultRules: RegisterOptions = {
  required: 'Campo requerido',
  maxLength: {
    value: 100,
    message: 'Máximo 100 caracteres',
  },
};

export const ControlledVideoAgreementTemplateNameInput = ({
  control,
  rules = {},
  textFieldProps = {},
}: ControlledVideoAgreementTemplateNameInputProps) => {
  const name = 'name';
  const {
    field: { onChange, onBlur, value },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: { ...defaultRules, ...rules },
  });

  const hasError = Boolean(error);
  const helperText =
    error?.message ||
    'Asegúrate de escribir correctamente el nombre para evitar plantillas de texto duplicadas.';

  return (
    <TextInput
      id={textFieldProps.id || name}
      value={value}
      onChange={(e) => {
        const inputValue = applySanitizers({
          text: e.target.value,
          sanitizers: ['capitalizeFirstLetter'],
        });
        onChange(inputValue);
      }}
      onBlur={(e) => {
        const inputValue = applySanitizers({
          text: e.target.value,
          sanitizers: ['removeExtraSpaces'],
        });
        onChange(inputValue);
        onBlur();
      }}
      error={hasError}
      helperText={helperText}
      {...textFieldProps}
    />
  );
};
